import React, { useState } from "react";
import { ContentLayout } from "../UI/Template/ContentLayout";
import { Leftpart } from "../UI/Template/Leftpart";
import Sidebar from "../Layout/Sidebar";
import { RightPart } from "../UI/Template/Rightpart";
import { Box, Tabs,Tab } from "@mui/material";
import PropTypes from 'prop-types';
import FilesTracker from "./FilesTracker";
import SystemError from "./SystemError";
import { useErrorLogData } from "../../hooks/useErrorLogData";
import WithConditional from "../hoc/WithConditional";
import Loader from "../UI/Loader";

function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;


    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
        </div>
    );
}

CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const AuditLogs = () => {
    const [tabValue, setTabValue] = useState(0);
    const handleChangeTabvalue = (e, newValue) => {
        setTabValue(newValue)
    }

    return (
        <ContentLayout>
            
            <Leftpart>
                <Sidebar />
            </Leftpart>
            <RightPart>
            <Box sx={{ width: '100%' }}>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                        <Tabs value={tabValue} onChange={handleChangeTabvalue} aria-label="basic tabs example">
                            <Tab label="Files Tracker" {...a11yProps(0)} />
                            <Tab label="System Errors" {...a11yProps(1)} />
                        </Tabs>
                    </Box>
                    <CustomTabPanel value={tabValue} index={0}>
                         <FilesTracker />
                    </CustomTabPanel>
                    <CustomTabPanel value={tabValue} index={1}>
                         <SystemError  />
                    </CustomTabPanel>
                </Box>
            </RightPart>
        </ContentLayout>
    )
}

export default AuditLogs;